import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../admin/app';
import DashboardWidget from './DashboardWidget';
import AnnouncementList from './AnnouncementList';
import Icon from '../../common/components/Icon';
import Button from '../../common/components/Button';
import Tooltip from '../../common/components/Tooltip';
const HIDDEN_KEY = 'flarum.announcements.hidden';
export default class AnnouncementsWidget extends DashboardWidget {
  constructor() {
    super(...arguments);
    _defineProperty(this, "announcements", null);
    _defineProperty(this, "loadError", false);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "hidden", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.hidden = localStorage.getItem(HIDDEN_KEY) === '1';
    if (!this.hidden) {
      this.load();
    }
  }
  className() {
    return 'AnnouncementsWidget' + (this.hidden ? ' AnnouncementsWidget--hidden' : '');
  }
  async load(bust) {
    if (bust === void 0) {
      bust = false;
    }
    this.loading = true;
    this.loadError = false;
    m.redraw();
    try {
      const url = app.forum.attribute('apiUrl') + '/flarum/announcements' + (bust ? '?bust=1' : '');
      const data = await app.request({
        method: 'GET',
        url
      });
      this.announcements = data;
    } catch (e) {
      this.loadError = true;
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  toggleHidden() {
    this.hidden = !this.hidden;
    if (this.hidden) {
      localStorage.setItem(HIDDEN_KEY, '1');
    } else {
      localStorage.removeItem(HIDDEN_KEY);
      if (!this.announcements && !this.loading) {
        this.load();
      }
    }
    m.redraw();
  }
  content() {
    return m('[', null, m("div", {
      className: "AnnouncementsWidget-header"
    }, m("h2", {
      className: "AnnouncementsWidget-title"
    }, m(Icon, {
      name: "fas fa-bullhorn"
    }), app.translator.trans('core.admin.announcements.title'), m(Tooltip, {
      text: app.translator.trans('core.admin.announcements.about')
    }, m("span", {
      className: "AnnouncementsWidget-info"
    }, m(Icon, {
      name: "fas fa-info-circle"
    })))), m("div", {
      className: "AnnouncementsWidget-controls"
    }, !this.hidden && m(Tooltip, {
      text: app.translator.trans('core.admin.announcements.refresh')
    }, m(Button, {
      className: "Button Button--icon",
      icon: this.loading ? 'fas fa-sync-alt fa-spin' : 'fas fa-sync-alt',
      disabled: this.loading,
      onclick: () => this.load(true)
    })), m(Tooltip, {
      text: app.translator.trans(this.hidden ? 'core.admin.announcements.show' : 'core.admin.announcements.hide')
    }, m(Button, {
      className: "Button Button--icon",
      icon: this.hidden ? 'fas fa-eye' : 'fas fa-eye-slash',
      onclick: () => this.toggleHidden()
    })))), !this.hidden && m(AnnouncementList, {
      announcements: this.announcements,
      loading: this.loading,
      error: this.loadError,
      onRetry: () => this.load()
    }));
  }
}
flarum.reg.add('core', 'admin/components/AnnouncementsWidget', AnnouncementsWidget);